<script setup>
import { onMounted, ref, watch } from 'vue'
import Modal from './Modal.vue'

const props = defineProps({
  linkText: {
    type: String,
      default: 'Show modal'
  },
  modalContent: {
    type: String,
    default: 'Modal Test',
    required: true
  }
})

let showModal = ref(false)
let title = ref('')
let content = ref('')

// Get content from the API endpoint that's set through the modalContent prop
async function getContent() {
  await fetch(props.modalContent)
  .then((response) => response.json())
  .then((data) => {
    title.value = data.Name
    content.value = data.Text
  })
}

onMounted(() => {
  getContent()
})

// If modal is opened, append the no-scroll class to the html element
watch(showModal, (value) => {
  if (value) {
    document.documentElement.classList.add('no-scroll')
  } else {
    document.documentElement.classList.remove('no-scroll')
  }
})
</script>

<template>
  <a href="#" class="tw-opacity-50" @click.prevent="showModal = true">{{ linkText }}</a>

  <Modal :show="showModal" @close="showModal = false">
    <template #modal-title>
      {{  title  }}
    </template>
    <template #content>
      <div v-html="content"></div>
    </template>
  </Modal>
</template>
